import { WsTemplate } from "@storyboard/web-client";

export interface WsTemplateExtended extends WsTemplate {
  authorName?: string;
  role?: string;
  canEdit?: boolean;
  disabled?: boolean;
  cloned?: boolean;
}

export type TemplateList = {
  myTemplates: WsTemplateExtended[];
  notMyTemplates: WsTemplateExtended[];
};

export type UseTemplates = {
  count: number;
  templates: TemplateList;
  cloneTemplate: (id: string) => Promise<WsTemplateExtended | undefined>;
  saveTemplate: ({ name, template }: { name: string; template: string }) => Promise<WsTemplateExtended | undefined>;
  deleteTemplate: (id: string) => Promise<null>;
  updateTemplate: ({
    id,
    name,
    template,
  }: {
    id: string;
    name: string;
    template: string;
  }) => Promise<WsTemplateExtended | undefined>;
};

export const allTemplatesSplit = ({
  templates,
  myAccountId,
  canEditOthers,
}: {
  templates: WsTemplateExtended[];
  myAccountId: string;
  canEditOthers: boolean;
}) => ({
  myTemplates: templates.filter((t) => t.authorId === myAccountId).map((template) => ({ ...template, canEdit: true })),
  notMyTemplates: templates
    .filter((t) => t.authorId !== myAccountId)
    .map((template) => ({ ...template, canEdit: canEditOthers })),
});
